import "./index.css";

export const Main = () => {
  return (
    <div className="container">
      <div className="indicator">
        <h1>Pantalla principal</h1>
      </div>
    </div>
  );
};
